import { useEffect, useState } from 'react'
import type { ServiceConfig } from '@/lib/types'

export function JsonInline({
  value,
  onChange,
}: {
  value: unknown
  onChange: (next: unknown) => void
}) {
  const [text, setText] = useState(() => JSON.stringify(value, null, 2))
  const [err, setErr] = useState<string | null>(null)

  useEffect(() => {
    setText(JSON.stringify(value, null, 2))
    setErr(null)
  }, [value])

  function commit(next: string) {
    setText(next)
    try {
      const parsed = JSON.parse(next)
      setErr(null)
      onChange(parsed)
    } catch (e) {
      setErr((e as Error).message)
    }
  }
  return (
    <div>
      <textarea
        value={text}
        spellCheck={false}
        onChange={(e) => commit(e.target.value)}
        rows={Math.min(20, Math.max(3, text.split('\n').length))}
        className="json-editor block w-full resize-y rounded border border-slate-200 bg-slate-50 p-2 outline-none focus:border-slate-400"
      />
      {err && <p className="mt-1 text-[11px] text-rose-600">{err}</p>}
    </div>
  )
}

export function JsonEditor({
  label,
  value,
  onChange,
}: {
  label: string
  value: unknown
  onChange: (next: unknown) => void
}) {
  const [text, setText] = useState(() => JSON.stringify(value, null, 2))
  const [err, setErr] = useState<string | null>(null)

  useEffect(() => {
    setText(JSON.stringify(value, null, 2))
    setErr(null)
  }, [value])

  function commit(next: string) {
    setText(next)
    try {
      const parsed = JSON.parse(next)
      setErr(null)
      onChange(parsed)
    } catch (e) {
      setErr((e as Error).message)
    }
  }

  return (
    <div>
      <p className="mb-1 text-[11px] uppercase tracking-wide text-slate-500">{label}</p>
      <textarea
        value={text}
        spellCheck={false}
        onChange={(e) => commit(e.target.value)}
        className="json-editor block h-[55vh] w-full resize-y rounded-lg border border-slate-200 bg-slate-50 p-3 outline-none focus:border-slate-400"
      />
      {err && <p className="mt-1 text-xs text-rose-600">JSON parse error: {err}</p>}
    </div>
  )
}

export function RawJsonView({ value }: { value: ServiceConfig }) {
  return (
    <pre className="json-editor max-h-[60vh] overflow-auto rounded border border-slate-200 bg-slate-50 p-3 text-xs">
      {JSON.stringify(value, null, 2)}
    </pre>
  )
}
